<div class="iq-card">
    <div class="iq-card-header d-flex justify-content-between">
       <div class="iq-header-title">
          <h4 class="card-title">Add Jury / Auditor</h4>
       </div>
       <div class="pull-right add">
        <a routerLink="/Jury" mat-stroked-button color="primary">Add New Jury / Auditor</a>
     </div>
    </div>
    <div class="iq-card-body company-list">
    <div class="form-group row">
        <div class="col-sm-12 col-lg-12">

            <div class="mat-elevation-z8">
                <mat-form-field appearance="outline" class="filter-dt">
                    <mat-label>Filter Data</mat-label>
                    <input (keyup)="applyFilter($event.target.value)" matInput placeholder="Filter Data">
                    <!-- <mat-icon matSuffix>sentiment_very_satisfied</mat-icon> -->
                    <!-- <mat-hint>Hint</mat-hint> -->
                  </mat-form-field>

                <table mat-table matSort [dataSource]="dataSource">
              
                  <!-- Position Column -->
                  <ng-container matColumnDef="sno">
                    <th mat-header-cell *matHeaderCellDef> # </th>
                    <td mat-cell *matCellDef="let element; let i = index;"> {{ (paginatorRef.pageIndex * paginatorRef.pageSize) + (i + 1) }}. </td>
                  </ng-container>
              
                  <!-- Name Column -->
                  <ng-container matColumnDef="juryName">
                    <th mat-header-cell *matHeaderCellDef> Jury Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.juryName}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="juryMobile">
                    <th mat-header-cell *matHeaderCellDef> Mobile </th>
                    <td mat-cell *matCellDef="let element"> {{element.juryMobile}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="juryExpertise">
                    <th mat-header-cell *matHeaderCellDef> Expertise </th>
                    <td mat-cell *matCellDef="let element"> {{element.juryExpertise}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="companyId">
                    <th mat-header-cell *matHeaderCellDef> Company </th>
                    <td mat-cell *matCellDef="let element"> {{element.companyId}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="businessUnitId">
                    <th mat-header-cell *matHeaderCellDef> Business Unit </th>
                    <td mat-cell *matCellDef="let element"> {{element.businessUnitId}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="plantId">
                    <th mat-header-cell *matHeaderCellDef> Plant </th>
                    <td mat-cell *matCellDef="let element"> {{element.plantId}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="juryEmployeeCode">
                    <th mat-header-cell *matHeaderCellDef> Employee Code </th>
                    <td mat-cell *matCellDef="let element"> {{element.juryEmployeeCode}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="juryOrganization">
                    <th mat-header-cell *matHeaderCellDef> Organization </th>
                    <td mat-cell *matCellDef="let element"> {{element.juryOrganization}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="juryPlace">
                    <th mat-header-cell *matHeaderCellDef> Place </th>
                    <td mat-cell *matCellDef="let element"> {{element.juryPlace}} </td>
                  </ng-container>
              
                  <ng-container matColumnDef="juryId">
                    <th mat-header-cell *matHeaderCellDef>Actions </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="material-icons icon-dt" title="Edit" routerLink="/Jury/{{ element.juryId }}">
                          edit
                        </span>&nbsp;&nbsp;
                        <span class="material-icons text-danger icon-dt" title="Delete" (click)=delete(element)>
                          delete_outline
                        </span>
                    </td>
                  </ng-container>
                  
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div *ngIf="dataSource.data.length === 0">
                    No Records Found!
                </div>
              
                <mat-paginator #paginatorRef [pageSize]="50" [pageSizeOptions]="[50, 100, 150]" showFirstLastButtons></mat-paginator>
              </div>


            <!-- <table class="table">
                <tr>
                    <th>#</th>
                    <th class="text-left">Jury Name</th>
                    <th class="text-center">Mobile</th>
                    <th class="text-center">Status</th>
                </tr>
                <tr *ngFor="let jury of juris; let ju = index">
                    <td>{{ ju+1 }}.</td>
                    <td class="text-left">{{ jury.juryName | titlecase }}</td>
                    <td class="text-center">{{ jury.juryMobile }}</td>
                    <td class="text-center">
                        <div class="custom-control custom-switch custom-switch-color custom-control-inline">
          <input type="checkbox" class="custom-control-input bg-info" id="customSwitch06" checked="">
          <label class="custom-control-label" for="customSwitch06"></label>
          <a routerLink="/Jury/{{ jury.juryId }}" title="{{ 'Edit '+jury.juryName | titlecase }}" class="edit"><i class="lar la-edit"></i></a>
          <a (click)=delete(jury) class="delete" title="{{ 'Delete '+jury.juryName | titlecase }}"><i class="lar la-trash-alt"></i></a>
       </div>
                    </td>
                </tr>
            </table> -->
        </div>
    </div>
                                  
    </div>
 </div>